import type { QueryClient } from '@tanstack/react-query';
import { invalidateItemsDataSet } from '@/lib/queries/common/useGetItemsDataSetQuery';
import { invalidateItems } from '@/lib/queries/common/useItems';
import { invalidateItemDescendants } from '@/lib/queries/item-store/useItemDescendants';
import { commonQueryKeys } from '@/lib/query-keys/common';

export const invalidateItemListQueries = (queryClient: QueryClient) => {
  invalidateItems(queryClient);
  invalidateItemsDataSet(queryClient);
  invalidateItemDescendants(queryClient);
  queryClient.invalidateQueries({ queryKey: commonQueryKeys.itemsTreeSet.all() });
};
